import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '../../services/modal.service';

import { I18nTranslator } from '../../i18n/translate';
import { Parcel } from '../../models/parcel.model';
import { ARBleService } from '../../services/agrorendement-ble.service';
import { ARColzaService } from '../../services/agrorendement-colza.service';
import { AROrgeService } from '../../services/agrorendement-orge.service';
import { ParcelService } from '../../services/parcel.service';
import { PlanningSelectParcel } from './planning-parcel.component';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

export class DatepickerDialogContext {
  parcel: any;
  parent: PlanningSelectParcel;
  selectedDate: Date;
  isAdmin: boolean;
  culture: string;
  passage: string;
  selectedParcels: Parcel[];
  campaignYear: number;
  showClose: boolean;
  isBlocking: boolean;
  size: string;
}

@Component({
  standalone: true,
  selector: 'planning-datepicker-dlg',
  templateUrl: 'planning-datepicker-dialog.component.html',
  imports: [TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule, BsDatepickerModule],
  providers: [ParcelService, ARColzaService, ARBleService, AROrgeService],
})
export class PlanningDatePickerDialogComponent implements OnInit {
  error: any;
  context: DatepickerDialogContext;
  parcel: Parcel;
  public datePicker: Date;
  public objectListName: string;
  public campaignYear: number;

  constructor(
    public dialog: DialogRef<DatepickerDialogContext>,
    private i18nTranslator: I18nTranslator,
    private router: Router,
  ) {
    this.context = dialog.context;
  }

  ngOnInit() {
    if (this.context) {
      this.campaignYear = new Date().getFullYear();
      if (this.context.campaignYear) {
        this.campaignYear = this.context.campaignYear;
      }
      if (this.context.selectedParcels && this.context.selectedParcels.length > 0) {
        // Join the names of the selected parcels with commas
        const totalItems = this.context.selectedParcels.length;
        const displayedItems = this.context.selectedParcels.slice(0, 10).map((parcel) => parcel.name);

        this.objectListName = displayedItems.join(', ') + (totalItems > 10 ? '...' : '');
      } else if (this.context.parcel) {
        this.objectListName = this.context.parcel.name;
      } else {
        console.error('Parcel data is missing:', this.context);
      }
    } else {
      console.error('Context data is missing:', this.context);
    }
  }
  confirm() {
    if (this.datePicker) {
      this.context.selectedDate = this.datePicker;

      this.context.parent.onDateSelected(this.datePicker, this.context.parcel);

      this.dialog.close();
    }
  }

  dismiss() {
    this.dialog.close();
  }

  moreThan3Days() {
    if (!this.datePicker || this.context.isAdmin) {
      return true;
    } else {
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = this.datePicker.getTime() - now.getTime();
      return time >= 259200000;
    }
  }
  isWorkDay() {
    if (this.datePicker) {
      //6 et 0 car 0 correspond au dimanche => Si pas le WeekEnd alors on check les jours fériés
      if (this.datePicker.getDay() !== 6 && this.datePicker.getDay() !== 0) {
        //1er janvier
        if (this.datePicker.getDate() === 1 && this.datePicker.getMonth() === 0) {
          return false;
          //1er mai
        } else if (this.datePicker.getDate() === 1 && this.datePicker.getMonth() === 4) {
          return false;
          //8 mai
        } else if (this.datePicker.getDate() === 8 && this.datePicker.getMonth() === 4) {
          return false;
          //14 juillet
        } else if (this.datePicker.getDate() === 14 && this.datePicker.getMonth() === 6) {
          return false;
          //15 Aout
        } else if (this.datePicker.getDate() === 15 && this.datePicker.getMonth() === 7) {
          return false;
          //1er novembre
        } else if (this.datePicker.getDate() === 1 && this.datePicker.getMonth() === 10) {
          return false;
          //11 novembre
        } else if (this.datePicker.getDate() === 11 && this.datePicker.getMonth() === 10) {
          return false;
          //25 décembre
        } else if (this.datePicker.getDate() === 25 && this.datePicker.getMonth() === 11) {
          return false;

          //fermeture annuelle wanaka
        } else if (this.datePicker.getDate() === 26 && this.datePicker.getMonth() === 11) {
          return false;
        } else if (this.datePicker.getDate() === 27 && this.datePicker.getMonth() === 11) {
          return false;
        } else if (this.datePicker.getDate() === 28 && this.datePicker.getMonth() === 11) {
          return false;
        } else if (this.datePicker.getDate() === 29 && this.datePicker.getMonth() === 11) {
          return false;
        } else if (this.datePicker.getDate() === 30 && this.datePicker.getMonth() === 11) {
          return false;
        } else if (this.datePicker.getDate() === 31 && this.datePicker.getMonth() === 11) {
          return false;

          //lundi de Pâques - à changer chaque année
        } else if (this.datePicker.getDate() === 29 && this.datePicker.getMonth() === 2) {
          return false;
          //jeudi de l'Ascension - à changer chaque année
        } else if (this.datePicker.getDate() === 6 && this.datePicker.getMonth() === 4) {
          return false;
          //lundi de Pentecôte - à changer chaque année
        } else if (this.datePicker.getDate() === 17 && this.datePicker.getMonth() === 4) {
          return false;
        }
        return true;
      } else {
        return false;
      }
      //Si pas de date => non bloquant
    } else {
      return true;
    }
  }

  //Important toujours mois avant le jours car sinon si notre mois actuel a 30 jours ca casse tout !
  isInSeason() {
    if (this.context.isAdmin) {
      return true;
    } else {
      if (this.datePicker) {
        const now = new Date();
        let year = this.campaignYear;
        if (now.getMonth() >= 7) {
          year = now.getFullYear() + 1;
        }

        if (this.context.culture === 'ble') {
          switch (this.context.passage) {
            case 'BLET1':
              const startBLET1 = new Date(year, 0, 1);
              const endBLET1 = new Date(year, 2, 31);
              return (
                this.datePicker.getTime() - startBLET1.getTime() >= 0 &&
                endBLET1.getTime() - this.datePicker.getTime() >= 0
              );
            case 'BLET2':
              const startBLET2 = new Date(year, 0, 1);
              const endBLET2 = new Date(year, 5, 15);
              return (
                this.datePicker.getTime() - startBLET2.getTime() >= 0 &&
                endBLET2.getTime() - this.datePicker.getTime() >= 0
              );
            case 'BLEDN':
              const startBLEDN = new Date(year, 2, 14);
              const endBLEDN = new Date(year, 5, 15);
              return (
                this.datePicker.getTime() - startBLEDN.getTime() >= 0 &&
                endBLEDN.getTime() - this.datePicker.getTime() >= 0
              );
            case 'BLET3':
              const startBLET3 = new Date(year, 2, 14);
              const endBLET3 = new Date(year, 5, 15);
              return (
                this.datePicker.getTime() - startBLET3.getTime() >= 0 &&
                endBLET3.getTime() - this.datePicker.getTime() >= 0
              );
          }
        } else if (this.context.culture === 'orge') {
          switch (this.context.passage) {
            case 'ORGET1': {
              const startORGET1 = new Date(year, 0, 1);
              const endORGET1 = new Date(year, 2, 31);
              return (
                this.datePicker.getTime() - startORGET1.getTime() >= 0 &&
                endORGET1.getTime() - this.datePicker.getTime() >= 0
              );
            }
            case 'ORGET2':
              const startORGET2 = new Date(year, 0, 1);
              const endORGET2 = new Date(year, 5, 15);
              return (
                this.datePicker.getTime() - startORGET2.getTime() >= 0 &&
                endORGET2.getTime() - this.datePicker.getTime() >= 0
              );
            case 'ORGET3':
              const startORGET3 = new Date(year, 0, 1);
              const endORGET3 = new Date(year, 5, 15);
              return (
                this.datePicker.getTime() - startORGET3.getTime() >= 0 &&
                endORGET3.getTime() - this.datePicker.getTime() >= 0
              );
          }
        } else if (this.context.culture === 'colza') {
          switch (this.context.passage) {
            case 'COLZAEH':
              const startCOLZAEH = new Date(year, 0, 14);
              const endCOLZAEH = new Date(year, 2, 31);
              return (
                this.datePicker.getTime() - startCOLZAEH.getTime() >= 0 &&
                endCOLZAEH.getTime() - this.datePicker.getTime() >= 0
              );
            case 'COLZASH':
              const startCOLZASH = new Date(year, 1, 15);
              const endCOLZASH = new Date(year, 4, 15);
              return (
                this.datePicker.getTime() - startCOLZASH.getTime() >= 0 &&
                endCOLZASH.getTime() - this.datePicker.getTime() >= 0
              );
          }
        }
        return false;
      } else {
        return true;
      }
    }
  }

  notInPast() {
    if (this.context.isAdmin) {
      return true;
    }
    if (this.datePicker) {
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = this.datePicker.getTime() - now.getTime();
      return time >= 0;
    }
    return true;
  }
}
